import LogoImage from '../../public/images/logo.svg'
import Image from 'next/image'
import {usePathname} from 'next/navigation'
import Link from 'next/link'
import useAuth from '@/hooks/useAuth'
import {useRouter} from 'next/router'

interface Props {
  settings: any
  featured_categories: any
}
export default function Footer({settings, featured_categories}: Props) {
  const {user} = useAuth('none')

  const path = usePathname()
  return (
    <footer className="bg-white pt-4 pb-3 mt-4 lg:pt-6">
      <div className="footer-container container-fluid">
        <div className="footer-about">
          <div className="footer-logo">
            <Image src={LogoImage} alt="logo-img" className="w-36" />
          </div>
          <p className="text-primary mt-2 font-light xl:max-w-[90%] 2xl:max-w-[80%]">
            {path == '/delivery_policy'
              ? `يمكنكم موقع "بصمتي" من ادراج اسماء اطفالكم الشخصية على جميع المنتوجات ,يمكنكم طلب قصة باسم طفلكم او طفلتكم حيث يكون هو بطل القصة , ويمكنكم طلب منتجات مثل الدفاتر واليوميات بالتصميم الذي تريدون بحيث يكون مطبوع مع اسم ابنكم او ابنتكم , كراسات تلوين وملصقات ,تجهيزات عيد الميلاد كلها مطبوعة باسم ابنكم , في الموقع تجدون ايضا منتجات للكبار حيث يمكنكم الموقع من اضافة اهداء او اسم شخصي على المنتج`
              : settings.about}
          </p>
        </div>
        <div className="links mt-6">
          <h3 className="text-success font-semibold text-xl">التصنيفات</h3>
          <ul className="mt-4">
            {featured_categories?.map((category: any) => {
              return (
                <li key={category.id}>
                  <Link href={`/products?categories=${category.slug}`}>
                    {category.name}
                  </Link>
                </li>
              )
            })}
          </ul>
        </div>
        <div className="links mt-6">
          <h3 className="text-success font-semibold text-xl">رعاية العملاء</h3>
          <ul className="mt-4">
            <li className="text-primary mt-2">
              <Link href="/cart">سلة المشتريات </Link>
            </li>
            {user && (
              <>
                <li className="text-primary mt-2">
                  <Link href="/account">الحساب الشخصي</Link>
                </li>
                <li className="text-primary mt-2">
                  <Link href="/account/address">العناوين</Link>
                </li>
                <li className="text-primary mt-2">
                  <Link href="/account/orders">طلباتي</Link>
                </li>
                <li className="text-primary mt-2">
                  <Link href="/account/wishlist">الكتب المفضلة</Link>
                </li>
              </>
            )}
          </ul>
        </div>
        <div className="links mt-6">
          <h3 className="text-success font-semibold text-xl">روابط عامة</h3>
          <ul className="mt-4">
            <li className="text-primary mt-2">
              <Link href="/">الرئيسية</Link>
            </li>
            <li className="text-primary mt-2">
              <Link href="/contactus">اتصل بنا</Link>
            </li>
            <li className="text-primary mt-2">
              <Link href="/aboutus">من نحن</Link>
            </li>
            <li className="text-primary mt-2">
              <Link href="/policies">شروط الأستخدام</Link>
            </li>
            <li className="text-primary mt-2">
              <Link href="/delivery_policy">سياسة التوصيل </Link>
            </li>
          </ul>
        </div>
        <div className="contact-info mt-6">
          <h3 className="text-success font-semibold text-xl">اتصل بنا</h3>
          <ul className="mt-4">
            <li className="text-primary flex items-center mt-2">
              <span>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.97942 1.71991C1.59787 2.10188 1.24802 2.57042 1.02182 2.97841C0.73771 3.47707 0.527973 4.02389 0.401523 4.59241L0.335719 4.93592C-0.701292 10.1972 0.615703 14.9038 4.96325 19.2204C7.81578 22.0526 9.97883 23.2164 12.9406 23.6413C13.4205 23.7102 13.9218 23.7619 14.5183 23.8061L15.7446 23.8806C16.429 23.916 17.5693 23.9728 17.9586 23.995C18.4713 24.0242 19.1496 23.9261 20.0612 23.7126L20.1993 23.6721C20.9951 23.391 21.7217 22.9349 22.3301 22.3258C24.5566 20.0969 24.5566 16.4831 22.3301 14.2542L22.1318 14.0648C19.9795 12.1049 16.6882 12.087 14.5158 14.0207L14.2582 14.2538L12.8817 15.6318C12.5801 15.9337 12.1051 15.9746 11.7564 15.7287C11.0309 15.217 9.10323 13.3304 8.63268 12.6874C8.37689 12.3378 8.41403 11.8537 8.72014 11.5474L9.93288 10.3341L10.0366 10.2497L10.1906 10.107C10.2184 10.0802 10.2467 10.0524 10.2748 10.0244C12.5655 7.73115 12.5655 4.01312 10.2748 1.71991C7.98407 -0.573303 4.27012 -0.573303 1.97942 1.71991ZM3.84006 3.58259C5.10315 2.31811 7.15103 2.31811 8.41413 3.58259C9.67722 4.84707 9.67722 6.8972 8.41413 8.16168C8.33598 8.23991 8.25458 8.31362 8.17014 8.38272L6.85998 9.68426C5.63541 10.9097 5.48685 12.846 6.51003 14.2442C7.15038 15.1192 9.28346 17.2069 10.2409 17.8822L10.4256 18.004C11.7998 18.8498 13.5882 18.6499 14.7424 17.4944L16.0149 16.2201L16.0323 16.2113L16.1549 16.0913C17.3559 14.9159 19.2803 14.9263 20.4695 16.1169C21.6684 17.3171 21.6684 19.2629 20.4695 20.4631L20.265 20.6505C20.0536 20.8276 19.822 20.9735 19.5753 21.0863L19.3762 21.1664L19.0379 21.2409L18.6807 21.3078C18.412 21.3528 18.2173 21.3712 18.1082 21.365L15.4364 21.2262L14.7286 21.1802L14.1146 21.1285C13.8268 21.1007 13.5647 21.0697 13.3138 21.0337C10.9428 20.6936 9.2858 19.802 6.8162 17.35C3.2278 13.7872 2.11555 10.1017 2.84874 5.81688L2.92544 5.40033C2.99495 4.9737 3.12368 4.60608 3.3151 4.27002C3.43164 4.05999 3.63432 3.78856 3.84006 3.58259Z"
                    fill="#00214D"
                  />
                </svg>
              </span>
              <div className="contact-info mr-4">
                <p className="text-primary opacity-25 text-sm">الهاتف</p>
                <a href={`tel:${settings.phone}`}>{settings.phone}</a>
              </div>
            </li>
            <li className="text-primary flex items-center mt-2">
              <span>
                <svg
                  width="28"
                  height="22"
                  viewBox="0 0 28 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.66797 0.332031C2.45883 0.332031 0.667969 2.12289 0.667969 4.33203V17.6654C0.667969 19.8745 2.45883 21.6654 4.66797 21.6654H23.3346C25.5438 21.6654 27.3346 19.8745 27.3346 17.6654V4.33203C27.3346 2.12289 25.5438 0.332031 23.3346 0.332031H4.66797ZM4.43532 3.01892C4.51087 3.00563 4.58861 2.9987 4.66797 2.9987H23.3346C23.414 2.9987 23.4918 3.00563 23.5673 3.01893L14.0013 9.39626L4.43532 3.01892ZM3.33464 5.49007V17.6654C3.33464 18.4017 3.93159 18.9987 4.66797 18.9987H23.3346C24.071 18.9987 24.668 18.4017 24.668 17.6654V5.49009L14.7409 12.1081C14.2931 12.4067 13.7096 12.4067 13.2617 12.1081L3.33464 5.49007Z"
                    fill="#00214D"
                  />
                </svg>
              </span>
              <div className="contact-info mr-4">
                <p className="text-primary opacity-25 text-sm">
                  البريد الإلكتروني
                </p>
                <a href={`mailto:${settings.email}`}>{settings.email}</a>
              </div>
            </li>
            <li className="text-primary flex items-center mt-2">
              <span>
                <svg
                  width="20"
                  height="28"
                  viewBox="0 0 20 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.0013 3.33464C6.3194 3.33464 3.33464 6.3194 3.33464 10.0013C3.33464 13.7185 5.48356 19.1577 10.0013 24.075C14.519 19.1577 16.668 13.7185 16.668 10.0013C16.668 6.3194 13.6832 3.33464 10.0013 3.33464ZM0.667969 10.0013C0.667969 4.84664 4.84664 0.667969 10.0013 0.667969C15.156 0.667969 19.3346 4.84664 19.3346 10.0013C19.3346 14.8709 16.4487 21.4395 10.9441 26.9441C10.4234 27.4648 9.57919 27.4648 9.05849 26.9441C3.5539 21.4395 0.667969 14.8709 0.667969 10.0013Z"
                    fill="#00214D"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.0013 11.3346C10.7377 11.3346 11.3346 10.7377 11.3346 10.0013C11.3346 9.26492 10.7377 8.66797 10.0013 8.66797C9.26492 8.66797 8.66797 9.26492 8.66797 10.0013C8.66797 10.7377 9.26492 11.3346 10.0013 11.3346ZM10.0013 14.0013C12.2104 14.0013 14.0013 12.2104 14.0013 10.0013C14.0013 7.79216 12.2104 6.0013 10.0013 6.0013C7.79216 6.0013 6.0013 7.79216 6.0013 10.0013C6.0013 12.2104 7.79216 14.0013 10.0013 14.0013Z"
                    fill="#00214D"
                  />
                </svg>
              </span>
              <div className="contact-info mr-4">
                <p className="text-primary opacity-25 text-sm">العنوان</p>
                <a href={`#`}>{settings.address}</a>
              </div>
            </li>
          </ul>
          <div className="socials mt-8 lg:mt-4">
            <ul className="flex items-center">
              {settings.social_medias.map((social: any, index: number) => {
                return (
                  <li className={index > 0 ? 'mr-6' : ''} key={index}>
                    <a href={social.url}>
                      <Image
                        src={
                          process.env.NEXT_PUBLIC_SITE_URL +
                          '/storage/' +
                          social.icon
                        }
                        width="25"
                        height="25"
                        alt={'social-icon'}
                      />
                    </a>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </div>
      <div className="footer-credits container-fluid text-primary pt-3 border-t mt-4 text-center">
        <p>
          Copyright {new Date().getFullYear()}{' '}
          <a href="https://nazadv.com" className="font-semibold text-center">
            BASMTI
          </a>{' '}
          . All rights reserved
        </p>
      </div>
    </footer>
  )
}
